import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import blueSVG from "../assets/images/blueBackground.png"; // Ensure the correct import path

const Vision = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });

    AOS.refresh();
  }, []);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 640); // 640px is Tailwind's sm breakpoint
    };

    // Check initially
    checkMobile();

    // Add event listener
    window.addEventListener("resize", checkMobile);

    // Cleanup
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <div
      className="relative overflow-hidden"
      style={{
        backgroundImage: `url(${blueSVG})`, // Dynamically set background image
        backgroundSize: isMobile ? "cover" : "100% 100%",
        backgroundPosition: "center", // Centers the image
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative z-10 py-16 sm:py-24 lg:py-32">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div
              className="flex flex-col lg:flex-row items-center justify-between gap-8 sm:gap-12"
              data-aos="fade-up"
            >
              {/* Text Content */}
              <div
                className="lg:w-1/2 text-center lg:text-left"
                data-aos="fade-right"
              >
                <h1 className="text-3xl sm:text-4xl lg:text-5xl text-gray-900 font-semibold leading-tight sm:leading-snug lg:leading-tight lg:ml-0 sm:ml-0">
                  Our Vision for
                  <br />
                  Agricultural and
                  <br />
                  Trading Businesses
                </h1>
              </div>

              {/* Description */}
              <div
                className="lg:w-1/2 text-center lg:text-left mt-6 sm:mt-8 lg:mt-0"
                data-aos="fade-left"
              >
                <p className="text-base sm:text-lg lg:text-xl font-semibold text-gray-900 leading-snug sm:leading-snug lg:leading-snug">
                  At Lightning Technologies, we envision a future where
                  agricultural and trading businesses thrive with the power of
                  cloud-based ERP solutions. Our user-friendly design and
                  transparent approach revolutionize the way businesses operate.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile View Customization */}
      <div
        className="absolute inset-0 z-0 bg-cover bg-center opacity-20 lg:opacity-50"
        data-aos="zoom-in"
      ></div>
    </div>
  );
};

export default Vision;
